import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.989}
    height={8.855}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 25301 8621"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#fefefe;stroke-width:280.382}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974618683040">
        <path
          d="M11507 5957h2287c277 0 502-226 502-503V3167c0-276-225-503-502-503h-2287c-277 0-503 227-503 503v2287c0 277 226 503 503 503zM17597 6084h2288c276 0 502-227 502-503V3294c0-276-226-502-502-502h-2288c-276 0-502 226-502 502v2287c0 276 226 503 502 503zM7704 6084H5416c-276 0-502-227-502-503V3294c0-276 226-502 502-502h2288c276 0 502 226 502 502v2287c0 276-226 503-502 503z"
          className="fill"
        />
        <path
          d="M2115 6505V2116h21071v4389H2115zM25161 140H140v8341h25021V140z"
          className="fill"
        />
        <path
          d="M11507 5957h2287c277 0 502-226 502-503V3167c0-276-225-503-502-503h-2287c-277 0-503 227-503 503v2287c0 277 226 503 503 503zM17597 6084h2288c276 0 502-227 502-503V3294c0-276-226-502-502-502h-2288c-276 0-502 226-502 502v2287c0 276 226 503 502 503zM7704 6084H5416c-276 0-502-227-502-503V3294c0-276 226-502 502-502h2288c276 0 502 226 502 502v2287c0 276-226 503-502 503z"
          className="fill"
        />
        <path
          d="M2115 6505V2116h21071v4389H2115zM25161 140H140v8341h25021V140z"
          className="fill"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
